import { User } from './user';

export interface Log {
    createdAt?: Date;
    createdBy?: User;
    updated?: boolean;
    updatedAt?: Date;
    updatedBy?: User;
    deleted?: boolean;
    deletedAt?: Date;
    deletedBy?: User;
}
